<template>
    <div class="body">
        <HeadDetailsGama :titleHead="'Retornar Listagem'"  :buttontemplate="true" :buttonbackCustom="true" style="font-family: 'Segoe UI';"></HeadDetailsGama>
        <div v-if="itemCabecalho.length > 0" id="tablog" style="width: 100%; display: flex; flex-direction: column; gap: 1rem">
            <div  style="display:flex;" v-for="data in itemCabecalho" :key="data.id">
              <div style="display: flex; flex-direction: column; width: 100%;">
                <label class="subtitle mt-2 mb-2">{{ data.descricao }}</label>
                <div>{{  data.resposta }}</div>
                <!-- <b-form-textarea
                 v-if="data.tipo === 0"
                id="textarea-auto-height"
                v-model="data.resposta"
                placeholder="Auto height textarea"
                disabled
                rows="1"
                max-rows="8"
                :auto-resize="true"
                ></b-form-textarea>
                <input v-if="data.tipo !== 0" disabled class="form-control text-left" type="text"  v-model="data.resposta" style="width: 100%"> -->
              </div>
              <hr>
            </div>
          </div>
          <div class="container_img" v-else>
            <img  class="img_notFound" :src="notFound">
            <div class="titulo_sem_registro">Nenhum registro encontrado!</div>
          </div>
    </div>
  </template>

<script>

import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import { loading } from '@/shared/utils/UIHelper'
import inqueryQmaRepository from '@/shared/http/repositories/business/qmaInquery.js'
import ImageNotFound from '../../../../../../../../static/img/qma/semDados.svg'

export default {
  name: 'logQma',
  mixins: [ActionsForm],
  components: {HeadDetailsGama, inqueryQmaRepository},
  data () {
    return {
      serachiput: '',
      idQma: null,
      itemCabecalho: [],
      notFound: ImageNotFound
    }
  },

  props: ['qma', 'propQma'],

  watch: {
  },

  mounted () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      const params = new URLSearchParams(window.location.search)
      params.forEach((value) => {
        this.idQma = value
      })
      loading.push()
      inqueryQmaRepository.GetCabecalho(this.idQma)
        .then(Response => {
          loading.pop()
          this.itemCabecalho = Response.data
          // this.itemCabecalho.forEach(item => {
          //   if (item.tipo === 2) {
          //     const dateStr = item.resposta
          //     const dateParts = dateStr.split('/')
          //     const day = parseInt(dateParts[0], 10)
          //     const month = parseInt(dateParts[1], 10) - 1
          //     const year = parseInt(dateParts[2], 10)

          //     const date = new Date(year, month, day)

          //     if (!isNaN(date.getTime())) {
          //       item.resposta = date
          //     }
          //   }
          // })
        })
        .catch(err => {
          loading.pop()
          console.log(err)
        })
    }
  }
}

</script>

    <style scoped>
  .body{
      width: 100%;
      height: 100%;
  }
  .input{
      width: 100%;
  }
  .form-control {
      display: block;
      width: 50%;
      height: calc(1.5em + 0.75rem + 2px);
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: 5px;
  }
  #greenChange {
      color: #008148;
  }

  .ballCrzy {
      width: 50px;
      height: 50px;
      border-radius:50%;
      border: 3px solid;
      font-size: 16px;
  }

  .ballCrzyDone {
      display: flex;
      justify-content: center;
      padding-top: 13px;
      font-size: 20px;
  }

  .squareCrzy {
      width: 60%;
      height: 62%;
      background: rgb(243, 241, 241);
      border-radius:1px 15px 15px;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      padding: 1rem 1rem 1rem 2rem;
      font-family: 'Segoe UI';
      display: flex;
      justify-content: space-between;
  }

  .textNum{
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
  }

  .Textneg2 {
      font-size: 12px;
      color:rgb(146, 149, 146);
      font-family:'Segoe UI';
      font-weight: bold;
      display: flex;
      column-gap: 1rem;
  }

  .Textneg {
      font-weight: bold;
      font-size: 14px;
      color:#008148;
  }

  .linhaSolid {
      height: 125px;
      border-left: 2px solid;
  }

  .icon-adjustment {
      display: flex;
      align-items: baseline;
      border-radius: 5px;
      gap: 0.5rem;
      position: relative;
      width: 20rem;
      border-radius: 5px;
  }

  .form-control {
      display: block;
      width: 100%;
      height: calc(1.5em + 0.75rem + 2px);
      padding: 0.375rem 0.75rem;
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: 5px;
      padding-left: 30px;
      }
  .linhaAling{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 3px;
      color: #008148;
  }

  #tablog{
      width: 100%;
  }

  .description-log {
      display: flex;
      gap: 1rem;
      font-family:'Segoe UI';
      align-items: center;
  }
  .input-search{
      width: 100%;
      display: flex;
      position: relative;
      gap: 1rem;
  }

  .icon-search{
      position: absolute;
      left: 10px;
      top: 10px;
      font-size: 14px;
  }
  .icone-search{
      position: absolute;
      left: 10px;
      top: 10px;
      font-size: 14px;
  }
  .search-container{
      position: relative;
  }

  .label-details-despesas{
    font-size: 14px;
    font-weight: bold;
    line-height: 2px;
}
.subtitle {
    font-size: 16px;
    color: #008144;
    font-weight: bold;
    font-family: 'Segoe UI';
  }

  .img_notFound{
    width: 20%;
    height: fit-content;
  }
  .titulo_sem_registro {
    margin-top: 1rem;
    font: normal normal normal 28px/33px Segoe UI;
    color: #008148;
  }
  .container_img{
    display: flex;
    justify-content: center;
    align-content: center;
    width: 100%;
    margin-top: 5rem;
    margin-bottom: 5rem;
    align-items: center;
    flex-direction: column;
  }
/*
  #tablog {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 16px; /* Space between columns
}

#tablog > div {
    flex: 1 1 calc(33.33% - 16px);
} */
  </style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/components/details/headingQma/headingQma.vue